// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-list-item {
  padding: 3px 20px;
  cursor: pointer;
  border:4px solid transparent;
  width: 50%;
  line-height: 1.5;
  text-align: center;
  color: gray;
}
.tab-list-active {

   border-radius: 30px;
   color:#7A7A7A; 
   background: transparent; 
   border:4px solid #4795DE;
   font-weight: 600;
   }
   /* Media Quries */
   @media (max-width:1024px){
     .tab-list-item {
         padding: 10px 20px;
     }  
 }`, "",{"version":3,"sources":["webpack://./src/Assets/css/LandingPage/Tab.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;;GAEG,mBAAmB;GACnB,aAAa;GACb,uBAAuB;GACvB,wBAAwB;GACxB,gBAAgB;GAChB;GACA,iBAAiB;GACjB;KACE;SACI,kBAAkB;KACtB;CACJ","sourcesContent":[".tab-list-item {\r\n  padding: 3px 20px;\r\n  cursor: pointer;\r\n  border:4px solid transparent;\r\n  width: 50%;\r\n  line-height: 1.5;\r\n  text-align: center;\r\n  color: gray;\r\n}\r\n.tab-list-active {\r\n\r\n   border-radius: 30px;\r\n   color:#7A7A7A; \r\n   background: transparent; \r\n   border:4px solid #4795DE;\r\n   font-weight: 600;\r\n   }\r\n   /* Media Quries */\r\n   @media (max-width:1024px){\r\n     .tab-list-item {\r\n         padding: 10px 20px;\r\n     }  \r\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
